import React, { useCallback, useEffect, useRef, useState } from 'react';
import useClickOutsideHandler from '../../HandleClickOutside';
import { ENVELOPE_ADDRESS_BLOCK, dummyCallback, SUPPORTED_ENVELOPE_TYPES } from '../../../../utils/complexDocumentConstants';
import { measurementConversion } from '../../../../utils/javascript';
import { getElementBySelectorAsync } from '../../complexDocumentHelper';
import {
  COMPLEX_DOCUMENT_CONTEXT_KEYS,
  useDocumentContext,
} from '../../../../context/complexDocumentContext';
import { CONTEXT_KEYS, useArtboardContext } from '../../../../context/complexArtboardContext';

function isRectAInsideRectB(rectA, rectB) {
  // rectA is inside rectB if:
  // - rectA's top is greater than or equal to rectB's top
  // - rectA's left is greater than or equal to rectB's left
  // - rectA's bottom is less than or equal to rectB's bottom
  // - rectA's right is less than or equal to rectB's right
  return (
    rectA.top >= rectB.top &&
    rectA.left >= rectB.left &&
    rectA.bottom <= rectB.bottom &&
    rectA.right <= rectB.right
  );
}

export const AddressWindow = ({ pageId }) => {
  const windowRef = useRef();
  const [validAddressPos, setValidAddressPos] = useState(false);
  const [containerStyle, setContainerStyle] = useState({});
  const addressBlockContentsRef = useRef();

  const envelopeAddressBlockSelector = useCallback(
    state => state[pageId].addressBlockUUID,
    [pageId],
  );
  const [addressBlock, methods] = useDocumentContext(envelopeAddressBlockSelector);

  const envelopeAddrContentsSelector = useCallback(
    state => state[addressBlock]?.contents,
    [addressBlock],
  );
  const [addressBlockContents] = useDocumentContext(envelopeAddrContentsSelector);

  const addressElementSelector = useCallback(
    state => state[addressBlock]?.contents.find(el => el.uiType === 'address')?.uuid,
    [addressBlock],
  );
  const [addressElementUUID] = useDocumentContext(addressElementSelector);

  const hybridMailSelector = useCallback(store => store[CONTEXT_KEYS.IS_HYBRID_MAIL], []);
  const [isHybridMail] = useArtboardContext(hybridMailSelector, `AddressWindow`);

  const envelopeTypeSelector = useCallback(store => store[CONTEXT_KEYS.SELECTED_ENVELOPE_TYPE], []);
  const [envelopeType] = useArtboardContext(envelopeTypeSelector, `AddressWindow`);

  useEffect(() => {
    if (addressElementUUID) {
      addressBlockContentsRef.current = addressBlockContents;
      getElementBySelectorAsync(`[id="q-container-${addressElementUUID}"]`).then(elementDOM => {
          const parentRect = windowRef.current?.getBoundingClientRect();
          const elementRect = elementDOM?.getBoundingClientRect();

          if (parentRect && elementRect && isRectAInsideRectB(elementRect, parentRect)) {
            setValidAddressPos(true);
          } else {
            setValidAddressPos(false);
          }
      });
    } else {
      setValidAddressPos(false);
    }
  }, [addressBlockContents, addressElementUUID]);

  useEffect(() => {
    const style = SUPPORTED_ENVELOPE_TYPES[envelopeType]; // TODO : Auto position the address block and persist offline storage
    setContainerStyle({
      position: 'absolute',
      zIndex: 3,
      transform: `translateX(${measurementConversion(style.x, 'px')}px) translateY(${measurementConversion(style.y, 'px')}px) rotate(${style.rotate}deg)`,
      width: `${measurementConversion(style.width, 'px')}px`,
      height: `${measurementConversion(style.height, 'px')}px`,
      border: `2px solid ${validAddressPos ? 'green' : 'red'}`,
      pointerEvents: 'none'
    });
  }, [envelopeType, validAddressPos]);

  return (
    <div /*onBlur={() => setIsSelected(false)} ref={containerRef}*/ id={'hybridAddressValidator'}>
      <span
        style={containerStyle}
        ref={windowRef}
        /*onClick={() => {
          if(editable && !isInteractiveDesign)
          setIsSelected(true);
        }}*/
      >
      </span>
    </div>
  );
};
